let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8u2dK")).then(() => parcelRequire('8i35h'));